import 'react-datepicker/dist/react-datepicker.css'
import '@fontsource-variable/roboto-flex'
import '@/index.css'

import { Toaster } from '@barfacil/barfacil-ui'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/App'
import { Toaster as LocalToaster } from '@/components/ui/toaster'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />

    <Toaster />
    <LocalToaster />
    {/* workaround to avoid unmount some components */}
  </StrictMode>,
)
